import React, { useCallback, useEffect, useState } from 'react';


import { Collapse } from 'antd';
import { Tabs } from 'antd';
import { fixDecimals } from 'helpers';
import { RELATIVE_METRICS } from 'config/constants';

const { TabPane } = Tabs;
const { Panel } = Collapse;

type CondensedMobileType = {
        rows:any[],
        showHighlights?:any
  }

const CondensedMobile =({rows, showHighlights}:CondensedMobileType) =>{

rows.sort(function(a, b) {
    return b.metrics.totalDis - a.metrics.totalDis;
});

const [zoneType, setZoneType]=useState(false);
 return(
     <>
    <div className="title-head">
    PLAYERS DETAILS
    <div className="switch-zone">
      <b>Team</b>
      <input type="checkbox" id="id-name--20" name="set-name" className="switch-input" onChange={()=>{
          if(zoneType){
            setZoneType(false);
          }else{
            setZoneType(true);
          }
      }}
      checked={zoneType}/>
      <label htmlFor="id-name--20" className="switch-label"></label>
      <b>Player</b>
    </div>
  </div>
  <div className={ showHighlights? "body-summary": "body-collapse"}  >
    <Collapse defaultActiveKey={['1']} className="ant-collapse-icon-position-right">
        {rows.map((player, index)=>

      <Panel
        header={
          <div className="collapse-h">
            <h6>{player.name}</h6>
            <h6>#{player.jerseyNumber}</h6>
            <h6>{player.position}</h6>
            <div className="date-head"><b>T. SPEED</b> <span>{fixDecimals(zoneType? player.metrics.targetMPHRelative : player.metrics.targetMPH, 1)}</span></div>
            <div className="date-head"><b>TOTAL DIST</b> <span>{player.metrics.totalDis} ({+fixDecimals(player.metrics['historyTotalDistance_%'] * 100, 0) >=0?
            fixDecimals(player.metrics['historyTotalDistance_%'] * 100, 0) :'-' }%)</span></div>
            <div className="date-head"><b>MAX SPEED</b> <span>{fixDecimals(player.metrics.maxSpeedMPH, 2)} 
              ({Number.isInteger(+fixDecimals(zoneType? player.metrics['maxSpeedMPHAs%ofTarget_Relative'] * 100 :
            player.metrics['maxSpeedMPHAs%ofTarget'] * 100, 0))?
            fixDecimals(zoneType? player.metrics['maxSpeedMPHAs%ofTarget_Relative'] * 100 : player.metrics['maxSpeedMPHAs%ofTarget'] * 100 , 0) :'-'}%)</span></div>
            <div className="date-head"><b>MAX SUST. SPEED</b> <span>{fixDecimals(player.metrics.maxSustainedSpeedMPH, 2)} ({Number.isInteger(+fixDecimals(zoneType?
            player.metrics['maxSustSpeedMPHAs%ofTarget_Relative'] * 100 : player.metrics['maxSustSpeedMPHAs%ofTarget'] * 100, 0))?
            fixDecimals(zoneType? player.metrics['maxSustSpeedMPHAs%ofTarget_Relative'] * 100 : player.metrics['maxSustSpeedMPHAs%ofTarget'] * 100, 0) :'-'}%)</span></div>
          </div>}
        key={index +1}
      >
        <Tabs defaultActiveKey="1">
          <TabPane tab="DISTANCES" key="1">
            <p><b>TOTAL DIST</b> <span>{player.metrics.totalDis} ({+fixDecimals(player.metrics['historyTotalDistance_%'] * 100, 0)>=0?
            fixDecimals(player.metrics['historyTotalDistance_%'] * 100, 0) :'-'}%)</span></p>
            <p><b>HARD EFF.  DIST.</b> <span>{zoneType? player.metrics.hardEffortDistRelative:
            player.metrics.hardEffortDist} ({+fixDecimals(zoneType? player.metrics['historyHardEffortDistanceRelative_%']* 100 : player.metrics['historyHardEffortDistance_%'] * 100, 0)>=0?
            fixDecimals(zoneType? player.metrics['historyHardEffortDistanceRelative_%']* 100 : player.metrics['historyHardEffortDistance_%'] * 100, 0):'-'}%)</span></p>
            <p><b>WALK</b> <span>{zoneType?player.metrics.walkYdsRelative : player.metrics.walkYds}</span></p>
            <p><b>JOG</b> <span>{zoneType? player.metrics.jogYdsRelative : player.metrics.jogYds}</span></p>
            <p><b>RUN</b> <span>{zoneType? player.metrics.runYdsRelative : player.metrics.runYds}</span></p>
            <p><b>SPRINT</b> <span>{zoneType? player.metrics.sprintYdsRelative : player.metrics.sprintYds}</span></p>
            <p><b>MAX SPRINT</b> <span>{zoneType? player.metrics.maxSprintYdsRelative : player.metrics.maxSprintYds}</span></p>
          </TabPane>
          <TabPane tab="COUNTS" key="2">
            <p><b>TOTAL DIST</b> <span>{player.metrics.totalDis} ({+fixDecimals(player.metrics['historyTotalDistance_%'] * 100, 0)>=0?
            fixDecimals(player.metrics['historyTotalDistance_%'] * 100, 0) :'-'}%)</span></p>
            <p><b>HARD EFF.  DIST.</b> <span>{zoneType? player.metrics.hardEffortDistRelative: player.metrics.hardEffortDist}
            ({+fixDecimals(zoneType? player.metrics['historyHardEffortDistanceRelative_%']* 100 : player.metrics['historyHardEffortDistance_%'] * 100, 0)>=0?
            fixDecimals(zoneType? player.metrics['historyHardEffortDistanceRelative_%']* 100 : player.metrics['historyHardEffortDistance_%'] * 100, 0):'-' }%)</span></p>
            <p><b>WALK</b> <span>{zoneType? player.metrics.walkCountRelative : player.metrics.walkCount}</span></p>
            <p><b>JOG</b> <span>{zoneType? player.metrics.jogCountRelative : player.metrics.jogCount}</span></p>
            <p><b>RUN</b> <span>{zoneType? player.metrics.runCountRelative : player.metrics.runCount}</span></p>
            <p><b>SPRINT</b> <span>{zoneType? player.metrics.sprintCountRelative : player.metrics.sprintCount}</span></p>
            <p><b>MAX SPRINT</b> <span>{zoneType? player.metrics.maxSprintCountRelative : player.metrics.maxSprintCount}</span></p>
          </TabPane>
          <TabPane tab="ACCELS" key="3">
            <p><b>LOW</b> <span>{player.metrics.accelSlow}</span></p>
            <p><b>MED.</b> <span>{player.metrics.accelMed}</span></p>
            <p><b>HIGH</b> <span>{player.metrics.accelFast}</span></p>
          </TabPane>
          <TabPane tab="DECELS" key="4">
            <p><b>LOW</b> <span>{player.metrics.deccelSlow}</span></p>
            <p><b>MED.</b> <span>{player.metrics.deccelMed}</span></p>
            <p><b>HIGH</b> <span>{player.metrics.deccelFast}</span></p>
          </TabPane>
        </Tabs>
      </Panel>
    )}
    </Collapse>
  </div>
</>
 );
};

export default CondensedMobile;
